import React from "react";

const BouncingDotsLoader = (props) => {
    return (
        <div className="bouncing-loader">
            <div style={{backgroundColor: props.color}}></div>
            <div style={{backgroundColor: props.color}}></div>
            <div style={{backgroundColor: props.color}}></div>
        </div>
    );
};

export default BouncingDotsLoader;